import { render, staticRenderFns } from "./PageLoaderDialog.vue?vue&type=template&id=73d9a4e6&scoped=true"
import script from "./PageLoaderDialog.vue?vue&type=script&lang=js"
export * from "./PageLoaderDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d9a4e6",
  null
  
)

export default component.exports